export const TITLE_PLACEHOLDER = '{ProductName}';
export const DEFAULT_COMPANY_NAME = 'ADYOUNEED';

export function createTitle(name: string, productName?: string): string {
  return `${productName || TITLE_PLACEHOLDER} - ${name}`;
}
